import { createSlice } from '@reduxjs/toolkit';
import { DpdPlacesStateType } from 'src/types/dpdPlaces';
import { formatData, formatDataCountries } from './functions';

const initialState: DpdPlacesStateType = {
    loading: false,
    data: null,
    dataCountries: null,
    error: false,
};
export const dpdPlacesSlice = createSlice({
    name: 'dpdPlaces',
    initialState,
    reducers: {
        getDpdPlacesFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getDpdPlacesFetchSuccess: (state, action) => {
            state.data = formatData(action.payload.data);
            state.loading = false;
        },
        getDpdPlacesFetchFailure: (state, action) => {
            // state.data = {};
            state.loading = false;
            state.error = true;
        },
        getDpdCountriesFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getDpdCountriesFetchSuccess: (state, action) => {
            state.dataCountries = formatDataCountries(action.payload.data);
            state.loading = false;
        },
        getDpdCountriesFetchFailure: (state, action) => {
            state.dataCountries = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getDpdPlacesFetch,
    getDpdPlacesFetchSuccess,
    getDpdPlacesFetchFailure,
    getDpdCountriesFetch,
    getDpdCountriesFetchSuccess,
    getDpdCountriesFetchFailure,
} = dpdPlacesSlice.actions;

export default dpdPlacesSlice.reducer;
